/*
 *  ~ Copyright (c) by INFODATA-GROUP. All rights reserved.
 *  ~ No part of this publication may be reproduced, distributed,
 *  ~ or transmitted in any form or by any means, including photocopying, recording,
 *  ~ or other electronic or mechanical methods, without the prior written permission of the publisher,
 *  ~ except in the case of brief quotations embodied in critical
 *  ~ reviews and certain other noncommercial uses permitted by copyright law.
 *  ~ Author : BS
 *  ~ Date : 2/8/23, 3:51 PM
 */

import { Factory } from '@infodata-group/inf-commons';
import { AoReportDetail } from '../../model/report/ao-report-detail';
import { AoReport } from '../../model/report/ao-report';

export class ReportFactory implements Factory<AoReport> {
  api: string;
  constructor(api: string) {
    this.api = api;
  }
  build(o: any): AoReport {
    const rapport = new AoReport(o.id);
    rapport.sal = o.sal;
    rapport.salId = o.salId;
    rapport.bbx = o.bbx;
    rapport.date = o.date;
    rapport.start = o.start;
    rapport.end = o.end;
    rapport.totalTemps = o.totalTemps;
    rapport.totalDeplacement = o.totalDeplacement;
    rapport.totalChantier = o.totalChantier;
    rapport.totalPause = o.totalPause;
    rapport.totalTravail = o.totalTravail;
    rapport.vitesseMoyenne = isNaN(Number(o.vitesseMoyenne))
      ? 0
      : Number(o.vitesseMoyenne);
    rapport.vitesseMaximum = isNaN(Number(o.vitesseMaximum))
      ? 0
      : Number(o.vitesseMaximum);
    rapport.freinageBrutaux = isNaN(Number(o.freinageBrutaux))
      ? 0
      : Number(o.freinageBrutaux);
    rapport.accelerationBrutales = isNaN(Number(o.accelerationBrutales))
      ? 0
      : Number(o.accelerationBrutales);
    rapport.coteConducteur = isNaN(Number(o.coteConducteur))
      ? 0
      : Number(o.coteConducteur);
    rapport.km = isNaN(Number(o.totalKm)) ? 0 : Number(o.totalKm);
    rapport.totalKm = isNaN(Number(o.totalKm)) ? 0 : Number(o.totalKm);

    rapport.detail = [];
    for (const det of o.detail) {
      const reportDetail = new AoReportDetail();
      reportDetail.heureDebut = det.heureDebut;
      reportDetail.heureFin = det.heureFin;
      reportDetail.duree = det.duree;
      reportDetail.km = det.km ? det.km : 0;
      reportDetail.position = det.position;
      reportDetail.latitude = det.latitude;
      reportDetail.longitude = det.longitude;
      reportDetail.adresse = det.adresse;
      reportDetail.chantier = det.chantier;
      reportDetail.chauf = det.chauf;
      reportDetail.com = det.com;
      reportDetail.grpChantier = {
        id: det.grpChantier.id,
        lib: det.grpChantier.id,
      };
      reportDetail.vehicule = {
        bbx: det.vehicule.bbx,
        lib: det.vehicule.lib,
        imm: det.vehicule.imm,
      };
      rapport.detail.push(reportDetail);
    }

    return rapport;
  }

  getApi(): string {
    return this.api;
  }
}
